var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBeginning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 20,
    viewBox: "0 0 12 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 5.54691C12 8.60926 9.3125 11.0938 6 11.0938C2.68625 11.0938 0 8.60926 0 5.54691C0 2.4834 2.68625 0 6 0C9.3125 0 12 2.4834 12 5.54691ZM6.66667 2.46529C6.66667 2.12477 6.36667 1.84897 6 1.84897C3.75417 1.84897 2 3.50457 2 5.54691C2 5.88589 2.29833 6.16323 2.66667 6.16323C3.03333 6.16323 3.33333 5.88589 3.33333 5.54691C3.33333 4.18715 4.52917 3.08162 6 3.08162C6.36667 3.08162 6.66667 2.80581 6.66667 2.46529ZM4.66667 18.4897V12.2148C5.1 12.2879 5.54583 12.2918 6 12.2918C6.45417 12.2918 6.9 12.2879 7.33333 12.2148V18.4897C7.33333 19.1715 6.7375 19.7223 6 19.7223C5.2625 19.7223 4.66667 19.1715 4.66667 18.4897Z",
    fill: "#100E34"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeginning);
export default __webpack_public_path__ + "static/media/beginning.775c8c084a7ed2c7c3c4903efac605ea.svg";
export { ForwardRef as ReactComponent };